import { IonCol, IonGrid, IonRow, useIonToast } from "@ionic/react";
import { FormattedMessage, useIntl } from "react-intl";

import ButtonLink from "@components/typography/ButtonLink";
import Heading2 from "@components/typography/Heading2";
import useMutationWithValidation from "@hooks/useMutationWithValidation";
import {
  GetClientWithAccountQuery,
  WorkEmailConfirmationSendDocument,
  WorkEmailConfirmationSendMutation,
  WorkEmailConfirmationSendMutationVariables
} from "@typing/Generated";
import { IconList } from "@utils/iconUtils";

type Props = {
  client: GetClientWithAccountQuery["client"];
};

const SecurityWorkEmailResend = ({ client }: Props) => {
  const [present, dismiss] = useIonToast();
  const intl = useIntl();

  const [workEmailConfirmationSend] = useMutationWithValidation<
    WorkEmailConfirmationSendMutation,
    WorkEmailConfirmationSendMutationVariables
  >(WorkEmailConfirmationSendDocument, "email");

  const presentWorkEmailError = () => {
    present({
      buttons: [{ handler: () => dismiss(), icon: IconList.xmark }],
      color: "danger",
      cssClass: "toast",
      duration: 4000,
      message: intl.formatMessage({ id: "pages.resendConfirmWorkEmail.failed" }),
      position: "top"
    });
  };

  const handleResendEmail = () => {
    if (!client.workEmail || !client.needsWorkEmailVerification) return;

    workEmailConfirmationSend({
      email: client.workEmail.email
    })
      .then(res => {
        if (res?.workEmailConfirmationSend?.errors.length === 0) {
          present({
            buttons: [{ handler: () => dismiss(), icon: IconList.xmark }],
            color: "success",
            cssClass: "toast",
            duration: 4000,
            message: intl.formatMessage({ id: "pages.resendConfirmWorkEmail.sent" }),
            position: "top"
          });
        } else {
          presentWorkEmailError();
        }
      })
      .catch(() => {
        presentWorkEmailError();
      });
  };

  return (
    <IonGrid className="ion-padding">
      <IonRow>
        <IonCol>
          <Heading2 bold color="black">
            <FormattedMessage id="pages.client.account.privacyAndAccount.sections.resendVerification" />
          </Heading2>
        </IonCol>
        <IonCol size="auto">
          <ButtonLink onClick={handleResendEmail}>
            <FormattedMessage id="dictionary.resend" />
          </ButtonLink>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default SecurityWorkEmailResend;
